import { render } from "./AppAlert.vue?vue&type=template&id=52af25cb&ts=true"
import script from "./AppAlert.vue?vue&type=script&lang=ts"
export * from "./AppAlert.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/package/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__